/**
 * Two handles on one track: a range, low end to high end. Two native range inputs lie over each other, so keyboard,
 * touch and screen readers work as they do for any slider; the handles cannot cross.
 */
export function RangeSlider({ min, max, step = 1, low, high, onChange, disabled, label, testId, lowLabel, highLabel }: {
  min: number; max: number; step?: number; low: number; high: number; onChange: (low: number, high: number) => void;
  disabled?: boolean; label: string; testId: string; lowLabel?: string; highLabel?: string;
}) {
  const pct = (v: number) => ((v - min) / (max - min)) * 100;
  return (
    <div className={`range-slider${disabled ? " disabled" : ""}`} data-testid={testId}>
      <div className="range-track" />
      <div className="range-fill" style={{ left: `${pct(low)}%`, width: `${Math.max(0, pct(high) - pct(low))}%` }} />
      <input type="range" min={min} max={max} step={step} value={low} disabled={disabled}
        aria-label={`${label}, lowest`} data-testid={`${testId}-low`}
        onChange={(e) => onChange(Math.min(Number(e.target.value), high), high)} />
      <input type="range" min={min} max={max} step={step} value={high} disabled={disabled}
        aria-label={`${label}, highest`} data-testid={`${testId}-high`}
        onChange={(e) => onChange(low, Math.max(Number(e.target.value), low))} />
      <div className="range-ends"><span>{lowLabel ?? min}</span><span>{highLabel ?? max}</span></div>
    </div>
  );
}
